import * as actionTypes from '../actions/actionType';

const filterDeveloperDetailsReducer = (state = {}, action = {}) => {
  switch (action.type) {
    case actionTypes.DEVELOPER_FILTERDETAILS:
      return action.data;
    default:
      return state;
  }
};

export default filterDeveloperDetailsReducer;
